import { Injectable } from '@angular/core';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import { from, Observable } from 'rxjs';

PouchDB.plugin(PouchDBFind);
export interface ClientDoc {
  _id: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export default class SousTraitantService {
  private db = new PouchDB('sous_traitants');
  all(): Observable<ClientDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'sous_traitant' },
        limit: undefined,
      })
      .then((res) => res.docs as unknown as ClientDoc[]);

    return from(promise);
  }
}
